import { Component, h, State } from '@stencil/core';
import { getReview } from '@ugc-api/review';
import { getReviewMoreImagesData, toSingleReviewInfo } from '@ugc-components/ugc-pdp-review/utils';
import state from '@ugc-store';
import { isRtl, handleErrorMessage } from '@ugc-utils/utils';
import { modalZIndex } from '@ugc-utils/modal-z-index';

@Component({
  tag: 'ugc-review-mw-all-images-detail-modal',
  styleUrl: 'ugc-review-mw-all-images-detail-modal.scss',
  shadow: false,
})
export class UgcReviewMwAllImagesDetailModal {
  @State() isLoading = false;

  handleSwipeLeft = () => {
    this.getPrevImage();
  };
  handleSwipeRight = () => {
    this.getNextImage();
  };
  handleCancel = () => {
    state.isShowCustomerAllImagesDetailModal = false;
  };

  getImageGallaryImage = () => {
    const {
      reviewImageListData: { items },
      activeImageAssetId,
    } = state;
    const activeimageIndex = items.findIndex(item => item.assetId === activeImageAssetId);
    return {
      left: activeimageIndex === 0 ? '' : items[activeimageIndex - 1],
      center: items[activeimageIndex],
      right: activeimageIndex === items.length - 1 ? '' : items[activeimageIndex + 1],
    };
  };

  getPrevImage = async () => {
    this.getPrevOrNextImage('prev');
  };
  getNextImage = async () => {
    const {
      reviewImageListData: { items },
      activeImageAssetId,
    } = state;
    const activeimageIndex = items.findIndex(item => item.assetId === activeImageAssetId);
    if (!items[activeimageIndex + 1]) {
      await getReviewMoreImagesData();
      this.getPrevOrNextImage('next');
    }
    this.getPrevOrNextImage('next');
  };

  getPrevOrNextImage = async flag => {
    const {
      reviewImageListData: { items },
      activeImageAssetId,
      activeImageReviewId,
    } = state;
    const activeimageIndex = items.findIndex(item => item.assetId === activeImageAssetId);
    const imageIndex = flag === 'prev' ? activeimageIndex - 1 : activeimageIndex + 1;
    if (items[imageIndex]) {
      const { assetId: prevAssetId, reviewId: prevReviewId } = items[imageIndex];
      state.activeImageAssetId = prevAssetId;
      if (activeImageReviewId !== prevReviewId) {
        //get reviewContent
        state.activeImageReviewId = prevReviewId;
        await this.getReviewDataById(prevReviewId);
      }
    }
  };

  async getReviewDataById(reviewId) {
    if (this.isLoading) return;
    try {
      this.isLoading = true;
      const data = (await getReview(reviewId)) || {};
      this.isLoading = false;
      state.customerImagesDetailModalData = toSingleReviewInfo(data);
    } catch (e) {
      this.isLoading = false;
      handleErrorMessage(e);
    }
  }

  render() {
    const {
      isShowCustomerAllImagesDetailModal,
      customerImagesDetailModalData,
      reviewStaticLanguage: { IDS_LBL_REVIEW_IMAGES } = {},
    } = state;

    const images = this.getImageGallaryImage();

    return (
      <ugc-drawer
        isShow={isShowCustomerAllImagesDetailModal}
        modalTitle={IDS_LBL_REVIEW_IMAGES}
        isShowButton={false}
        zIndex={modalZIndex['ugc-review-all-images-detail-modal']}
        handleCancel={this.handleCancel}
      >
        {isShowCustomerAllImagesDetailModal && (
          <div class="my-16" style={{ height: '80vh', overflowY: 'auto' }}>
            <ugc-swipe handleSwipeLeft={this.handleSwipeLeft} handleSwipeRight={this.handleSwipeRight} isRTL={isRtl()}>
              <div class="ugc-review-mw-all-images-detail-modal-wrap">
                {Object.keys(images).map(key => {
                  const item = images[key];
                  return (
                    <div class={`image-item ${key}`}>
                      {item && item.paths && item.paths.l && (
                        <img
                          key={item.assetId}
                          src={item.paths.l}
                          style={{ height: '327px' }}
                          alt="image"
                          class="border-1 border-solid border-gray-300 rounded-4 pointer"
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </ugc-swipe>

            <div class="py-16 px-24  ugc-customer-images-detail-content-wrap">
              <ugc-review-item
                key={customerImagesDetailModalData.id}
                reviewItem={customerImagesDetailModalData}
                isModal={true}
              />
              <div class={`ugc-customer-images-detail-content-mantle ${this.isLoading ? 'active' : ''}`} />
            </div>
          </div>
        )}
      </ugc-drawer>
    );
  }
}
